import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const LINEUP_POSITIONS = ["P", "C", "1B", "2B", "SS", "3B", "LF", "CF", "RF", "DH", "EH", "Bench"];
const blank = () => ({ name: "", position: "Bench", note: "" });

export const LineupEditor = ({ initial, onClose, onSave }) => {
  const [form, setForm] = useState(initial || { name: "", entries: Array.from({ length: 9 }, blank), notes: "" });
  const [busy, setBusy] = useState(false);
  const setEntry = (i, patch) => setForm((f) => ({ ...f, entries: f.entries.map((e, j) => (j === i ? { ...e, ...patch } : e)) }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const entries = form.entries.filter((x) => x.name.trim()).map((x) => ({ ...x, name: x.name.trim(), note: x.note?.trim() || null }));
    try { await onSave({ name: form.name.trim(), entries, notes: form.notes?.trim() || null }); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="lineup-editor">
        <DialogHeader><DialogTitle className="font-heading text-2xl uppercase">{initial ? "Edit lineup" : "New lineup"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="lineup-name-input" className="field-input w-full" required maxLength={60} placeholder="Lineup name, e.g. vs Tigers 6/14"
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <div className="space-y-2">
            {form.entries.map((en, i) => (
              <div key={i} className="lineup-row">
                <span className="font-heading text-xl font-extrabold text-center">{i + 1}</span>
                <input data-testid={`lineup-player-input-${i}`} className="field-input !min-h-[44px] min-w-0" maxLength={40} placeholder="Player"
                  value={en.name} onChange={(e) => setEntry(i, { name: e.target.value })} />
                <div className="flex gap-1">
                  <select data-testid={`lineup-position-select-${i}`} className="field-input !min-h-[44px] !px-1 flex-1 min-w-0" value={en.position} onChange={(e) => setEntry(i, { position: e.target.value })}>
                    {LINEUP_POSITIONS.map((p) => <option key={p} value={p}>{p}</option>)}
                  </select>
                  <button type="button" className="text-[var(--muted)]" aria-label="Remove" data-testid={`lineup-remove-${i}`}
                    onClick={() => setForm((f) => ({ ...f, entries: f.entries.filter((_, j) => j !== i) }))}><X size={16} /></button>
                </div>
              </div>
            ))}
          </div>
          {form.entries.length < 20 && (
            <button type="button" className="btn-ghost w-full !text-base" data-testid="lineup-add-player" onClick={() => setForm((f) => ({ ...f, entries: [...f.entries, blank()] }))}>
              <Plus size={18} /> Add player
            </button>
          )}
          <textarea data-testid="lineup-notes-input" className="field-input w-full min-h-[70px]" maxLength={1000} placeholder="Coaches' notes for this lineup (subs, pitch counts, matchups)"
            value={form.notes || ""} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
          <button className="btn-primary w-full" data-testid="lineup-save-button" disabled={busy}>Save lineup</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
